<template>
  <transition name="el-zoom-in-top">
    <!-- {{ maxHeight + 1111 }} -->
    <div
      class="main"
      :style="{
        height: ' 46vh',
        'max-height': '100vh',
        'margin-bottom': (maxHeight / 1920) * 100 + 'vw',
      }"
      v-show="loadOver"
    >
      <!-- height:  40+(maxHeight / 1920) * 100 + 'vw',
        'max-height':  40+(maxHeight / 1920) * 100 + 'vw', -->
      <!-- 'margin-bottom': (maxHeight/2/ 1920) * 100 + 'vw', -->
      <p class="line"></p>
      <img
        src="../../assets/image/hualeft.png"
        alt=""
        @click="loadMore(params, false)"
      />
      <!-- <transition name="el-zoom-in-top"> -->
      <div v-for="(item, index) in pageList" :key="index">
        <div :style="{ background: color[index] }">{{ item.title }}</div>
        <div
          v-html="item.content"
          :style="{
            height: (maxHeight / 1920) * 100 + 'vw',
            top: index % 2 == 0 ? -(maxHeight / 1920) * 100 + 'vw' : '5.208vw',
            'justify-content': index % 2 == 0 ? 'flex-end' : 'flex-start',
          }"
          class="rich"
        ></div>
      </div>
      <img
        src="../../assets/image/huanright.png"
        alt=""
        @click="loadMore(params, true)"
      />
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "devHistoryG",
  data() {
    return {
      maxHeight: 192,
      top: {
        top: "-5.208vw",
      },
      bottom: {
        top: "5.208vw",
        background: "#f00",
      },
      color: ["#FF7F11", "#FFB122", "#72DE33", "#84BF44", "#F7DD55"],
      loadOver: false,
      list: [],
      info: {},
      params: {
        page: 1,
        limit: 4,
      },
      hasMore: true,
    };
  },
  computed: {
    ...mapGetters(["pageCate", "meanCenterObj"]),
    pageList() {
      let list = this.list.slice(-4);
      list.push({
        content: "",
        title: "Thefuture",
      });
      return list;
    },
    // maxHeight() {
    //   if (this.loadOver) {
    //     this.$nextTick(() => {
    //       let richArr = Array.prototype.slice.call(
    //         document.getElementsByClassName("rich")
    //       );
    //       let heightArr = [];
    //       for (let prop in richArr) {
    //         heightArr.push(richArr[prop].clientHeight);
    //       }
    //       let aa = Math.max(...heightArr) || 192;
    //       // console.log(heightArr, aa, 999);
    //       return aa;
    //     });
    //   }
    // },
  },
  created() {
    this.$nextTick(() => {
      this.getList();
    });
  },
  watch: {
    loadOver(a) {
      if (a) {
        this.$nextTick(function () {
          // this.getmaxHeight();
        });
      }
    },
  },
  methods: {
    richStyle() {
      var regex = new RegExp("<span>", "gi");
      res.data.keyWord = res.data.keyWord.replace(regex, "< span class=''>");
    },
    getmaxHeight() {
      let richArr = Array.prototype.slice.call(
        document.getElementsByClassName("rich")
      );
      let heightArr = [];
      for (let prop in richArr) {
        heightArr.push(richArr[prop].clientHeight);
      }
      let maxHeight = Math.max(...heightArr);
      this.maxHeight = maxHeight || 192;
      // console.log(heightArr, this.maxHeight, 999);
    },
    getList() {
      this.$api.CATE(this.meanCenterObj.tabId, this.params).then((res) => {
        let length = res.list.length;
        if (length < this.params.limit) {
          this.hasMore = false;
        }
         var regex = new RegExp("<span", "gi");
        res.list.forEach(i => {
          i.content.replace(regex, "<span class='aaa'");
        });
        this.list.push(...res.list);
        this.loadOver = true;
        console.log(this.list,555);
      });
    },
    loadMore(params, type) {
      // 下一页
      if (type) {
        if (this.hasMore) {
          params.page += 1;
        } else {
          this.$message({
            type: "warning",
            message: "暂无更多",
          });
          return;
        }
      } else {
        if (params.page == 1) {
          this.$message({
            type: "warning",
            message: "已是最开始",
          });
          return;
        } else {
          params.page -= 1;
        }
      }
      this.loadOver = false;
      this.$api.CATE(this.meanCenterObj.tabId, this.params).then((res) => {
        if (length < this.params.limit) {
          this.hasMore = false;
        }
        this.list.push(...res.list);
        this.loadOver = true;
        // console.log(this.list, "加载更多");
      });
    },
  },
};
</script>

<style lang='less' scoped>
.main {
  width: 77.7vw;
  // width: 1492px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // overflow: hidden;
  > .line {
    margin-left: 15%;
    width: 70%;
    height: 0.3125vw;
    background-image: linear-gradient(to right, #bfe2ff, #1680d9);
    position: absolute;
  }
  > img {
    width: 1vw;
    height: 1vw;
    cursor: pointer;
  }
  > img:hover {
    transform: scale(1.2);
  }
  > div {
    flex: flex 0 0 80%;
    text-align: center;
    position: relative;
    // background: #f00;
    > div:first-child {
      width: 4.16vw;
      height: 4.16vw;
      border: 0.52vw solid #fff;
      box-shadow: 0 0 0.52vw 0.52vw #eee;
      border-radius: 50%;
      font-weight: bold;
      font-size: 0.78125vw;
      color: #fff;
      text-align: center;
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      justify-content: center;
    }
    > div:last-child {
      min-width: 18vw;
      // min-width: 192px;
      position: absolute;
      text-align: left;
      display: flex;
      flex-flow: column;
      left: -5.72vw;
      font-size: .7vw !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/go/devHistoryG.vue